import React from 'react';
import styled from 'styled-components';
import Tooltip from 'components/Tooltip';
import Icon from 'kingpin/atoms/Icon';
import GlobalSearch from 'components/GlobalSearch';

export const SearchButton = styled.button`
  height: 32px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 120px 3px 8px;
  border: 1px solid var(--color-border-primary);
  border-radius: 10px;
  background-color: var(--color-bg-primary);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  color: var(--color-text-muted);
  cursor: pointer;
  width: 100%;
  box-shadow:
    0px 3px 2px -1px rgba(0, 0, 0, 0.02),
    0px 1px 1px -1px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
  &:hover {
    border-color: var(--color-border-primary);
    background-color: var(--color-bg-tertiary);
  }

  &:focus {
    outline: none;
  }
`;

const Search = () => {
  return (
    <GlobalSearch
      button={({ onClick }) => (
        <Tooltip
          content={'Search all your assets and resources'}
          hideTooltipOnClick
        >
          <SearchButton onClick={onClick}>
            <Icon
              icon="search"
              width={16}
              height={16}
              color={'var(--color-text-muted)'}
            />
            Search...
          </SearchButton>
        </Tooltip>
      )}
    />
  );
};

export default Search;
